
import { CheckCircle2 } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function ResetPasswordSuccess() {
  return (
    <Card className="w-full max-w-md">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl font-bold flex items-center gap-2">
          <CheckCircle2 className="h-6 w-6 text-green-500" />
          Password Reset Successful
        </CardTitle>
        <CardDescription>
          Your password has been successfully reset. You will be redirected to the login page shortly.
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
